import React, { useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { AppState } from '../store';
import { IChatSettingState } from '../store/chatSetting/types';
import ChatMessage from './ChatMessage';
import 'element-scroll-polyfill';
// import { IMessage } from '../store/chatmessage/types';
// import { AllProps } from '../containers/ChatMessageContainer';

interface IProps {
  setting: IChatSettingState;
}
const ChatMessageTree: React.FC<IProps> = props => {
  const dispatch = useDispatch();
  const messages = useSelector((state: AppState) => state.chatMessage);
  const chatBotBaseData = useSelector((state: AppState) => state.chatBaseData);
  const [scrollPosition, setScrollPosition] = React.useState(0);

  const reactions = chatBotBaseData
    ? chatBotBaseData.reduce((result: any, current: any, index: number) => {
        result[current.id] = current
        return result
      }, {})
    : {}

  useEffect(() => {
    const frameBody = document.querySelector('#chatbot-frame-body');
    if (frameBody != null) {
      frameBody.scroll({ top: scrollPosition, behavior: 'smooth' });
    }
  }, [scrollPosition]);

  const measureRef = useCallback(
    node => {
      if (node !== null && messages.length > 0) {
        setScrollPosition(node.scrollHeight);
      }
    },
    [messages]
  );

  useEffect(() => {
    localStorage.setItem('chat-message', JSON.stringify(messages));
  }, [messages]);

  if (messages.length === 0) {
    return <div />;
  }
  return (
    <React.Fragment>
      <div ref={measureRef}>
        {messages.map((message) => (
          <ChatMessage
            key={message.message_id}
            setting={props.setting}
            data={message}
            dispatch={dispatch}
            chatBotData={reactions}
          />
        ))}
      </div>
    </React.Fragment>
  )
};

export default ChatMessageTree;
